// B2a — shared "role not allowed here" outcome for the route guards. Redirects once to the role's home; if that
// redirect would loop (home is the current page, or we already arrived here from a denial) it renders the
// access-denied page instead of bouncing again.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AccessDenied from "../pages/AccessDenied";
import { homeRouteFor } from "../lib/roleHome";

export default function RoleDenied({ user }) {
  const location = useLocation();
  const home = homeRouteFor(user);
  if (location.state?.route_denied || home === location.pathname) return <AccessDenied />;
  return <Navigate to={home} replace state={{ route_denied: true, attempted: location.pathname }} />;
}
